// @ts-ignore
import Cookies from 'js-cookie';
import { useEffect, ReactNode, useCallback } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { setupInterceptors } from 'interceptors/axios';
import { useDispatch } from 'react-redux';
import { logoutUser } from 'modules/profile/redux/userActions';
import { getTenantConfig } from 'Auth0ProviderWithDynamicConfig';

interface AxiosAuthProviderProps {
  children: ReactNode;
}

export const AxiosAuthProvider = ({ children }: AxiosAuthProviderProps) => {
  const { getAccessTokenSilently, logout } = useAuth0();
  const dispatch = useDispatch();

  const onLogout = useCallback(async () => {
    const savedTenant = Cookies.get('authTenant');
    const tenantConfig = getTenantConfig(savedTenant);

    const returnTo = tenantConfig?.logout_uri ?? window.location.origin;

    try {
      await dispatch(logoutUser(logout));
      await logout({ logoutParams: { returnTo } });
    } catch (error) {
      await logout({ logoutParams: { returnTo } });
    }
  }, [dispatch, logout]);

  useEffect(() => {
    setupInterceptors(getAccessTokenSilently, onLogout);
  }, [getAccessTokenSilently, onLogout]);

  return children;
};
